import React from 'react';
import './Partners.css';

// Importing images
import partner1 from '../../assets/partners/partner1.svg';
import partner4 from '../../assets/partners/partner4.svg';
import blockchain from '../../assets/partners/blockchain.svg';
import bybit from '../../assets/partners/bybit.svg';
import okx from '../../assets/partners/okx.svg';

const partners = [
    {
        name: "BestChange",
        href: "https://www.bestchange.ru/",
        imgSrc: partner1,
        alt: "BestChange"
    },
    {
        name: "Binance",
        href: "https://www.binance.com",
        imgSrc: partner4,
        alt: "Binance"
    },
    {
        name: "Blockchain",
        href: "https://www.blockchain.com/",
        imgSrc: blockchain,
        alt: "Blockchain"
    },
    {
        name: "ByBit",
        href: "https://www.bybit.com/",
        imgSrc: bybit,
        alt: "ByBit"
    },
    {
        name: "OKX",
        href: "https://www.okx.com/",
        imgSrc: okx,
        alt: "OKX"
    }
];

const Partners = () => {
    return (
        <div className="partners-container">
            {partners.map((partner, index) => (
                <div key={index} className="partner-item">
                    <a href={partner.href} target="_blank" rel="noopener noreferrer">
                        <img
                            src={partner.imgSrc}
                            alt={partner.alt}
                            className="partner-logo"
                        />
                    </a>
                </div>
            ))}
        </div>
    );
};

export default Partners;
